module.exports = __webpack_public_path__ + "img/back_active4.37672bc0.png";